module.exports = __webpack_public_path__ + "static/media/who-we-are-img.eb1e83ce.jpg";